import { Hotspot } from './hotspot';
import { Partner } from './partner';

export enum IntegrationKinds {
  ADP = 'adp',
  LOKET = 'loket',
  HR2DAY = 'hr2day',
  TYOMARKKINATORI = 'tyomarkkinatori',
  HACKER_RANK = 'hacker_rank',
  JITSI = 'jitsi',
  DEV_SKILLER = 'dev_skiller',
  OFFICIENT = 'officient',
  ESKILL = 'eskill',
  GUSTO = 'gusto',
  KIWI_HR = 'kiwi_hr',
  JACANDO = 'jacando',
  ARBEITNOW = 'arbeitnow',
  AFAS = 'afas',
  GFEA = 'gfea',
  SYMPA = 'sympa',
  KUNUNU = 'kununu',
  ACME = 'acme',
  WONDERKIND = 'wonderkind',
  TEAMS = 'teams',
  HARVER = 'harver',
  INDEED = 'indeed',
  PREDICTIVE_INDEX = 'predictive_index',
  DOCU_SIGN = 'docu_sign',
  HELLO_SIGN = 'hello_sign',
  SIGN_REQUEST = 'sign_request',
  GOOGLE_HANGOUTS_MEET = 'google.hangouts_meet',
  ZOOM = 'zoom',
  LUCCA = 'lucca',
  NMBRS = 'nmbrs',
  ENBOARDER = 'enboarder',
  HOTELPROFESSIONALS = 'hotelprofessionals',
  HIBOB = 'hibob',
  WERKEN_IN_EEN_HOTEL = 'werken_in_een_hotel',
  APPICAL = 'appical',
  BRYQ = 'bryq',
  INTERVIEW_MOCHA = 'interview_mocha',
  TEST_DOME = 'test_dome',
  CODILITY = 'codility',
  PERSONIO = 'personio',
  BAMBOO = 'bamboo',
  CHECKR = 'checkr',
}

export interface IntegrationsElement {
  component: string;
  hotspot: Hotspot;
  integrationKind: IntegrationKinds | null;
  partner: Partner | null;
  inputs: { [key: string]: any };
  id: string | null;
}
